/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Why it was lifted. Null while it is active.
 */
export type VehicleSuspensionDtoLiftReason = typeof VehicleSuspensionDtoLiftReason[keyof typeof VehicleSuspensionDtoLiftReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleSuspensionDtoLiftReason = {
  FIXED: 'FIXED',
  FALSE_ALARM: 'FALSE_ALARM',
  OTHER: 'OTHER',
} as const;
